import { render, staticRenderFns } from "./RewardMy.vue?vue&type=template&id=991e904e&scoped=true&"
import script from "./RewardMy.vue?vue&type=script&lang=js&"
export * from "./RewardMy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991e904e",
  null
  
)

export default component.exports